var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.requests)?_c('user-requests',{attrs:{"first_name":_vm.dataUser.first_name,"last_name":_vm.dataUser.last_name,"requests":_vm.requests},on:{"done":_vm.done,"rich-bottom":_vm.richBottom}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }